import { Component, OnInit, ViewChild } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { PlanListComponent } from '../admin/plan-list.component';
import { Plan } from '../../models/AccountModel';

@Component({
  selector: 'app-plan-dashboard',
  templateUrl: './plan-dashboard.component.html',
  styleUrls: ['./plan-dashboard.component.scss']
})
export class PlanDashboardComponent implements OnInit {
  state='LIST';
  selectedPlan: Plan;

  @ViewChild(PlanListComponent) planList: PlanListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showAllPlans() {
    this.selectedPlan = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedPlan = new Plan();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedPlan = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedPlan = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
